import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie";
import moment from "moment";

// Import Assets
// import failureAnimation from "../../../../../assets/lottie/failure.json";
import { lottieAnimations } from "../../../utils/functions/lottieAnimations";

// Import Functions & Services
import TripServices from "../../../services/externalServices/trip/TripServices";
import { sendNotificationPaymentNotAccepted } from "../../../utils/functions/notification";
import releaseRidersFromBidLock from "../../../utils/functions/riders";

const PaymentFailure = ({
  packageName,
  selectedDate,
  selectedTime,
  cabRequestId,
  isAutoBid = false,
  rider,
  handleSendMessage,
  tripId,
}) => {
  const navigate = useNavigate();

  // Format Trip Date & Time
  const tripDateFormatted = selectedDate
    ? moment(selectedDate).format("DD MMM, YYYY")
    : "";
  const tripTimeFormatted = selectedTime
    ? moment(selectedTime).format("hh:mm A")
    : "";

  const notifyPartner = useCallback(async () => {
    const fcmTokens = rider?.fcm_token ? [rider.fcm_token] : [];
    const phoneNumbers = rider?.phone_number ? [rider.phone_number] : [];
    try {
      if (!isAutoBid && fcmTokens.length && phoneNumbers.length) {
        await sendNotificationPaymentNotAccepted({
          cabRequestId,
          fcmTokens,
          phoneNumbers,
        });
      }

      const updatedTripData = await TripServices.update(tripId, {
        status: "CANCELLED",
        cancelledBy: "Non-payment.",
      });

      if (updatedTripData) {
        console.log("Updated trip status to CANCELLED. Trip id:", tripId);
      }

      if (rider?.phone_number) {
        await releaseRidersFromBidLock([rider.phone_number]);
      }
    } catch (error) {
      console.log("error while sending payment failure notification", error);
    }
  }, [cabRequestId, isAutoBid, rider?.fcm_token, rider?.phone_number, tripId]);

  useEffect(() => {
    notifyPartner();
  }, [notifyPartner]);

  const handleRebook = () => {
    navigate("/"); // Change this to your actual home/dashboard route
  };

  // Lottie Animation Options
  const lottieOptions = {
    loop: false,
    autoplay: true,
    animationData: lottieAnimations.failure,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 text-gray-800 px-4">
  <div className="flex flex-col items-center justify-center mt-16">
    <Lottie options={lottieOptions} height={100} width={100} />
  </div>

  <div className="text-center mt-6">
    <h2 className="text-2xl font-bold">Payment Failed!</h2>
    <p className="text-lg text-gray-600 mt-2">
      Your {packageName || "tour package"} failed to book.
    </p>
  </div>

  {/* Responsive Card */}
  <div className="flex flex-col md:flex-row justify-center items-center mt-6 bg-white p-4 rounded-lg shadow-md w-full max-w-xl mx-auto space-y-4 md:space-y-0 md:space-x-4">
    <div className="flex-1 text-center">
      <p className="text-sm text-gray-500">Scheduled for</p>
      <p className="text-lg font-semibold">{tripDateFormatted}</p>
    </div>

    <div className="w-full h-px bg-red-500 md:w-px md:h-12"></div>

    <div className="flex-1 text-center">
      <p className="text-sm text-gray-500">Pickup at</p>
      <p className="text-lg font-semibold">{tripTimeFormatted}</p>
    </div>
  </div>

  <div className="flex flex-col items-center mt-8">
    <button
      className="bg-blue-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-blue-700 transition w-full max-w-xs"
      onClick={handleRebook}
    >
      Rebook Again
    </button>
  </div>

  <div className="mt-auto py-8 text-center">
    <button
      className="text-blue-500 text-sm underline"
      onClick={() => handleSendMessage("chatWithUs")}
    >
      Need Help? Chat with Us
    </button>
  </div>
</div>

  );
};

export default PaymentFailure;
